module.exports = __webpack_public_path__ + "static/media/ro-RO.fde568d6.md";